'use strict'

const SET_PROBEPLEX_LIST = 'SET_PROBEPLEX_LIST'
const CREATE_PROBEPLEX = 'CREATE_PROBEPLEX'
const UPDATE_PROBEPLEX = 'UPDATE_PROBEPLEX'
const DELETE_PROBEPLEX = 'DELETE_PROBEPLEX'

const PPP_UPDATE_SPECTRA_SOURCE = 'PPP_UPDATE_SPECTRA_SOURCE'

import format from 'string-format'

import api from '../../api'
import {ProbePlex} from '../../models/'

const initialState = {
	probePlex_list: [],
	probePlexes: {},
}

const actions = {
	// create_probePlex: function ({commit}, {probePlex, details = true}) {
	// 	console.debug(format(
	// 		"store.modules.probePlex.create_probePlex(, details: {details} )",
	// 		{details: details}))
	//
	// 	return api.probePlex.probePlex_create(probePlex, details)
	// 		.then(function (response) {
	// 			commit(CREATE_PROBEPLEX, ProbePlex(response.data))
	// 		})
	// },

	list_probePlex: function ({commit, rootState}, {project_id}) {
		console.debug('store.probePlex.list_probePlex()')

		return api.probePlex.probePlex_list(project_id)
			.then(function (response) {
				const data = Array.from(
					response.data,
					(pp) => new ProbePlex(pp, rootState))

				commit(SET_PROBEPLEX_LIST, data)
				return true
			})
			.catch(function (error) {
				commit(SET_PROBEPLEX_LIST, [])
				throw error
			})
	},

	update_probePlex: function ({commit, rootState}, {probePlex, details = true}) {
		console.debug(format(
			"store.modules.probePlex.update_probePlex( , details: {details} )",
			{details: details}))

		return api.probePlex.probePlex_update(probePlex, details)
			.then(function (response) {
				commit(UPDATE_PROBEPLEX, new ProbePlex(response.data, rootState))
			})
	},

	ppp_update_spectra_source({commit, rootState}, {ppp, plate_wells}) {
		console.debug(format(
			"store.modules.probePlex.ppp_update_spectra_source ()\n  {0}",
			JSON.stringify({ppp_id: ppp.id, plate_wells: plate_wells})))

		return api.probePlex.ppp_update_spectra_source(ppp, plate_wells)
			.then(function (response) {
				commit(PPP_UPDATE_SPECTRA_SOURCE,
					{ppp, plate_wells: response.data.plate_wells})
			})
	}
}

const mutations = {
	/**
	 *
	 * @param state
	 * @param data Array of ProbePlex objects
	 */
	[SET_PROBEPLEX_LIST](state, data) {
		state.probePlex_list = data
		state.probePlexes = Object.assign({}, ...data.map(
			(pp) => ({[pp.id]: pp})))
	},

	[UPDATE_PROBEPLEX](state, obj) {
		const tgt = state.probePlexes[obj.id]
		for (const key in tgt) {
			tgt[key] = obj[key]
		}
	},

	[PPP_UPDATE_SPECTRA_SOURCE](state, {ppp, plate_wells}) {
		state.probePlexes[ppp.probePlex.id].probes[ppp.id].plate_wells = plate_wells
	},
}

const getters = {
	probePlex_list: function (state) {
		return state.probePlex_list
	},

	probePlexes: function (state) {
		return state.probePlexes
	},
}

export default {
	namespaced: true,

	state: initialState,

	actions,
	mutations,
	getters,
}